import env from '../config/env';

export const SERVER_URL = env.API_BASE_URL;
export const BASE_URL = `${SERVER_URL}/api/`;

export const STORE_LOGIN = 'admin-login';

export const EDIT_DRIVER = 'edit-driver';
export const GET_DRIVERS_LIST = 'get-drivers-list';
export const GET_DRIVER_DETAILS_BY_ID = 'get-driver-details-by-id';
export const CHANGE_DRIVER_STATUS_BY_ADMIN = 'change-driver-status-by-admin';

export const CHANGE_DOCUMENT_STATUS = 'change-document-status';

export const GET_VEHICLE_LIST = 'get-vehicles-list';
export const EDIT_VEHICLE_DETAILS = 'edit-vehicle-details';
export const GET_VEHICLES_DETAILS_BY_ID = 'get-vehicles-details-by-id';
export const CHANGE_VEHICLE_STATUS_BY_ADMIN = 'change-vehicle-status-by-admin';

export const ISSUE = 'issue';
export const GET_ISSUE_CATEGORIES = 'get-issue-categories';

export const TRACK_CURRENT_RIDE = 'track-current-ride';
export const TRACK_COMPLETED_RIDE = 'track-completed-ride';
export const CURRENT_RIDE_DETAILS = 'current-ride-details';
export const COMPLETED_RIDE_DETAILS = 'completed-ride-details';

export const GET_ISSUE_LIST = 'get-issue-list';
export const GET_ISSUE_DETAILS = 'get-issue-details';
export const ISSUE_RESOLUTION = 'issue-resolution';

export const GET_GRIEVANCE_LIST = 'get-grievance-list';

export const DELETE_DRIVER_ACCOUNT = 'delete-driver-account';

export const LOGIN_USER = 'login-user';
export const GET_CATEGORIES = 'get-categories-store';
export const ADD_CATEGORY = 'add-category';
export const EDIT_CATEGORY = 'edit-category';
export const CREATE_ORDER = 'create-order';
export const GET_STORE_PRODUCTS_AVAILABLE = 'get-store-products-available';
export const ADD_DRAFT_ORDER = 'add-draft-order';
export const GET_DRAFT_ORDER_LIST = 'get-draft-order-list';
export const GET_DRAFT_ORDER_BY_ID = 'get-draft-order-by-id';
export const DELETE_DRAFT_ORDER ='/delete-draft-order';
export const GET_SUPPLIERS = 'get-suppliers';
export const GET_USER_PROFILE = 'get-user-profile/store';
// export const GET_INVOICE_LIST = 'get-invoice-list/store';
// export const GET_INVOICE_BY_ID = 'get-invoice-by-id/store';
export const GET_OUTER_INVOICE_LIST = 'get-outer-invoice-list/store';
export const GET_INNER_INVOICE_LIST = 'get-inner-invoice-list/store';
export const GET_INVOICE_BY_ID = 'get-invoice-by-id/store';

export const CHANGE_LANGUAGE = 'change-language/store';

export const SEND_MESSAGES = 'send-messages/store';
export const GET_MESSAGE_LIST = 'get-message-list/store';
export const REPLY_MESSAGE = 'reply-message/store';
export const GET_REPLIES = 'get-replies/store';
export const CHANGE_MESSAGE_STATUS = 'change-message-status/store';
export const GET_NAMES_STORE = 'get-names/store';
export const DELETE_MESSAGE = 'delete-message/store';
export const GET_NEW_MESSAGE_COUNT = 'get-new-message-count/store';

export const GET_ORDERS = 'get-orders';
export const GET_ORDER_BY_ID = 'get-order-by-id/store';
export const CREATE_NOTE = 'create-note/store';
export const GET_PRODUCTS = 'get-products';
export const CREATE_PRODUCT = 'create-product';
export const GET_STORE_PRODUCTS = 'get-store-products/store';
export const GET_PRODUCT = 'get-product/store';
export const GET_SUBCATEGORIES = 'get-subcategories';
export const UPDATE_PROFILE = 'update-profile/store';
export const PROFILE_IMAGE_UPLOAD = 'profile-image-upload/supplier';
export const GET_SHIPPINGS = 'get-shippings';
export const GET_SHIPPING = 'get-shipping';
export const GET_STORE = 'get-store/store';
export const ADD_SUBCATEGORY = 'add-subcategory';
export const EDIT_SUBCATEGORY = 'edit-subcategory';
export const GET_SUPPLIER_DETAILS = 'get-supplier-details';
export const UPDATE_PASSWORD = 'update-password/store';
export const GET_SHIPPING_LIST = 'get-shipping-list/store';
export const GET_SHIPPING_BY_ID = 'get-shipping-by-id/store';
export const GET_TAXES = 'get-taxes/provision';
export const CREATE_TAXES = 'create-taxes/provision';

export const GET_COUNTRY_LIST = 'get-country-list/store';
export const GET_STATE_LIST = 'get-state-list/store';

export const GET_SHIPPING_METHODS = 'get-shipping-methods';
export const CREATE_SHIPPING_METHOD = 'create-shipping-method';